import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 40px 0px 20px 0px;
`

export const TableContainer = styled.div`
  margin-right: 30px;
`

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30;
`

export const ViewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`

export const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  cursor: pointer;
`

export const WrapperEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const EmptyStateText = styled.h3`
  color: rgb(198, 1, 107);
`

export const LoaderWrapper = styled.div`
  margin: 80px 0px;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const JobStatusCard = styled.div`
  margin: 16px 30px 0 0;
  padding: 16px 18px;
  border: 1px solid #d9d9e3;
  border-radius: 8px;
  background: #ffffff;
`

export const JobStatusHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
`

export const JobStatusTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #2f2f43;
`

export const JobStatusMeta = styled.div`
  font-size: 0.9rem;
  color: #6b6b80;
`

export const ProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  background: #ececf3;
  border-radius: 999px;
  overflow: hidden;
`

export const ProgressFill = styled.div<{ $percent: number }>`
  width: ${({ $percent }) => `${$percent}%`};
  height: 100%;
  background: #c6016b;
  transition: width 0.3s ease;
`

export const JobStatusMessage = styled.div`
  margin-top: 10px;
  font-size: 0.92rem;
  color: #44445a;
`
